var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionItem',{attrs:{"disabled":_vm.disabled,"label":"View In App","icon":"mdi-map"},nativeOn:{"click":function($event){return _vm.launchCustomerSite()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }